import { MessageBox } from 'element-ui'
import Global from '@/components/Global.vue'
const moment = require('moment')

/* 機器一覧 : Status */
export function getStatusName(name) {
  switch (name) {
    case 0:
      return '運用開始前'
    case 1:
      return '運用中'
    case 2:
      return '停止中'
    case 3:
      return '撤去'
    default:
      return ''
  }
}

/* サービスステータス */
export function getServiceStatusName(name) {
  switch (name) {
    case '0':
      return '未利用'
    case '1':
      return '利用中'
    case '2':
      return '停止中'
    case '3':
      return '解約済み'
    default:
      return ''
  }
}

/* 機器一覧 検索結果 */
export function trimNull(value) {
  if (value == null || value === 'null') {
    return ''
  } else {
    return value
  }
}

/* ログイン画面、一括登録 : keyNameを変換する */
export function swtichName(name) {
  name = name.toString()
  switch (name) {
    case 'userName':
    case 'user_name':
      name = 'Email'
      break
  }
  return name
}

/* エラーメッセージを加工
 * switchedFlag: キー名が漢字に変換済みか true:変換済み false:未変換
 */
export function showErrorMessage(errorObject, switchedFlag) {
  var errorInfo = ''
  var errorMessageStr = ''

  if (switchedFlag) {
    for (var i = 0; i < errorObject.length; i++) {
      errorInfo = errorObject[i]
      if (errorInfo.description === null || errorInfo.description === '') {
        if (errorInfo.keyName === null || errorInfo.keyName === '') errorMessageStr += errorInfo.message + ' <br/> '
        else errorMessageStr += errorInfo.keyName + ' : ' + errorInfo.message + ' <br/> '
      } else if (errorInfo.description === undefined) {
        if (errorInfo.keyName === null || errorInfo.keyName === '') errorMessageStr += errorInfo.message + ' <br/> '
        else errorMessageStr += errorInfo.keyName + ' : ' + errorInfo.message + ' <br/> '
      } else {
        if (errorInfo.keyName === null || errorInfo.keyName === '') errorMessageStr += '(' + errorInfo.description + ') : ' + errorInfo.message + ' <br/> '
        else errorMessageStr += errorInfo.keyName + '(' + errorInfo.description + ') : ' + errorInfo.message + ' <br/> '
      }
    }
  } else {
    for (var j = 0; j < errorObject.length; j++) {
      errorInfo = errorObject[j]
      if (errorInfo.description === null || errorInfo.description === '') {
        if (errorInfo.keyName === null || errorInfo.keyName === '') errorMessageStr += errorInfo.message + ' <br/> '
        else errorMessageStr += swtichName(errorInfo.keyName) + ' : ' + errorInfo.message + ' <br/> '
      } else if (errorInfo.description === undefined) {
        if (errorInfo.keyName === null || errorInfo.keyName === '') errorMessageStr += errorInfo.message + ' <br/> '
        else errorMessageStr += swtichName(errorInfo.keyName) + ' : ' + errorInfo.message + ' <br/> '
      } else {
        if (errorInfo.keyName === null || errorInfo.keyName === '') errorMessageStr += '(' + errorInfo.description + ') : ' + errorInfo.message + ' <br/> '
        else errorMessageStr += swtichName(errorInfo.keyName) + '(' + errorInfo.description + ') : ' + errorInfo.message + ' <br/> '
      }
    }
  }

  return errorMessageStr
}

/* base64エンコード */
export function base64Encode(data) {
  var result = ''
  var toBase64Table = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
  var base64Pad = '='
  var length = data.length
  var i
  for (i = 0; i < (length - 2); i += 3) {
    result += toBase64Table[data.charCodeAt(i) >> 2]
    result += toBase64Table[((data.charCodeAt(i) & 0x03) << 4) + (data.charCodeAt(i + 1) >> 4)]
    result += toBase64Table[((data.charCodeAt(i + 1) & 0x0f) << 2) + (data.charCodeAt(i + 2) >> 6)]
    result += toBase64Table[data.charCodeAt(i + 2) & 0x3f]
  }

  if (length % 3) {
    i = length - (length % 3)
    result += toBase64Table[data.charCodeAt(i) >> 2]
    if ((length % 3) === 2) {
      result += toBase64Table[((data.charCodeAt(i) & 0x03) << 4) + (data.charCodeAt(i + 1) >> 4)]
      result += toBase64Table[(data.charCodeAt(i + 1) & 0x0f) << 2]
      result += base64Pad
    } else {
      result += toBase64Table[(data.charCodeAt(i) & 0x03) << 4]
      result += base64Pad + base64Pad
    }
  }
  return result
}

/** base64デコード */
export function base64Decode(input) {
  var keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
  var output = ''
  var chr1 = ''
  var chr2 = ''
  var chr3 = ''
  var enc1 = ''
  var enc2 = ''
  var enc3 = ''
  var enc4 = ''
  var i = 0

  if (input.length % 4 !== 0) {
    return ''
  }
  var base64test = /[^A-Za-z0-9+/=]/g
  if (base64test.exec(input)) {
    return ''
  }

  do {
    enc1 = keyStr.indexOf(input.charAt(i++))
    enc2 = keyStr.indexOf(input.charAt(i++))
    enc3 = keyStr.indexOf(input.charAt(i++))
    enc4 = keyStr.indexOf(input.charAt(i++))

    chr1 = (enc1 << 2) | (enc2 >> 4)
    chr2 = ((enc2 & 15) << 4) | (enc3 >> 2)
    chr3 = ((enc3 & 3) << 6) | enc4

    output = output + String.fromCharCode(chr1)

    if (enc3 !== 64) {
      output += String.fromCharCode(chr2)
    }
    if (enc4 !== 64) {
      output += String.fromCharCode(chr3)
    }

    chr1 = chr2 = chr3 = ''
    enc1 = enc2 = enc3 = enc4 = ''
  } while (i < input.length)
  output = output.replace(new RegExp('\\n', 'gm'), '<br>')
  return output
}

export function messageAlert(message) {
  MessageBox({
    title: 'Message',
    message: message,
    dangerouslyUseHTMLString: true,
    confirmButtonText: 'OK'
  })
}

export function selectTab(This) {
  let els = This.$el.getElementsByClassName('multiselect')
  for (var i = 0; i < els.length; i++) {
    els[i].tabIndex = 0
  }
}

export function getNowFormatDate() {
  var date = new Date()
  var seperator = '_'
  var year = date.getFullYear()
  var month = date.getMonth() + 1
  var strDate = date.getDate()
  if (month >= 1 && month <= 9) {
    month = '0' + month
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = '0' + strDate
  }
  var currentdate = year + seperator + month + seperator + strDate
  return currentdate
}

// list(json形式)にいずれの項目の権限が 2 になっているかをチェック
export function checkPrivilege(list) {
  for (let oneColumn in list) {
    if (list[oneColumn]['privilege'] === 2) {
      return true
    }
  }

  messageAlert('編集できる項目がありません。')
  return false
}

export function pageMessageProcess(data) {
  let chatData = JSON.parse(data.replace(/\n/g, '\\n').replace(/\r/g, '\\r'))
  if (chatData.type === 'replaced') {
    Global.otherPageReplacedMessage = true
  }
  if (typeof (chatData.chatId) === 'undefined' || chatData.chatId === '') {
    return
  }

  let receiveInfo = null
  if (parseInt(chatData.senderType) === 2) {
    receiveInfo = {
      chat_id: chatData.chatId,
      chat_message_id: chatData.chatMessageId,
      sender_type: '2',
      message_content: chatData.chatMessage,
      message_time: moment(new Date(chatData.chatDate)).format('YYYY-MM-DD HH:mm:ss').toString()
    }
  }

  // localStorageからチャットメッセージを取得
  let chatInfo = JSON.parse(localStorage.chatInfoList)

  let newArray = []
  chatInfo.forEach((element, index) => {
    // insert received message
    if (receiveInfo != null) {
      if (parseInt(receiveInfo.chat_id) === parseInt(element.chatId)) {
        element.has_unread_message = 1
        if (element.info.length !== 0) {
          element.info.push(receiveInfo)
        }
        // messageTop
        element.messageTop = 1
        newArray[0] = element
        newArray = newArray.concat(chatInfo.slice(0, index))
        newArray = newArray.concat(chatInfo.slice(index + 1, chatInfo.length))
      }
    }
  })
  chatInfo = newArray

  localStorage.chatInfoList = JSON.stringify(chatInfo)
}



//////////////////
// WEBPACK FOOTER
// ./static/js/common.js
// module id = /sA3
// module chunks = 1